import {
    headers, visitorTaxInvoiceListUrl, GET_VISITOR_TAX_INVOICE_LIST, GENERATE_VISITOR_TAX_INVOICE, generateVisitorTaxInvoiceUrl, SHARE_VISITOR_TAX_INVOICE, sendVisitorInvoiceMailUrl, generateAdditionalVisitorTaxInvoiceUrl
} from "../../../utils/constants"
import { axiosPost, axiosGet } from "../../../react_axios/Axios"
import moment from 'moment';

export const visitorTaxInvoiceList_action = (VisitorRegistrationNo, CompanyName, TaxInvoice_No) => async (dispatch) => {
    try {
        const params = {
            VisitorRegistrationNo: VisitorRegistrationNo,
            CompanyName: CompanyName,
            TaxInvoice_No: TaxInvoice_No,
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem("sessionExhibitionID"),
        }
        console.log("ReceiptListSearch -Action--------------------------->", params)

        const res = await axiosGet(visitorTaxInvoiceListUrl, params, headers);
        dispatch({
            type: GET_VISITOR_TAX_INVOICE_LIST,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
}

export const generateVisitorTaxInvoice_action = (ExhvisitorIDList) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem("sessionExhibitionID"),
            ExhvisitorIDList: ExhvisitorIDList,
        }
        console.log("ExhibitionID-Action--------------------------->", params)

        const res = await axiosPost(generateVisitorTaxInvoiceUrl, params, headers);
        dispatch({
            type: GENERATE_VISITOR_TAX_INVOICE,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const generateAdditionalVisitorTaxInvoice_action = (ExhvisitorIDList) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem("sessionExhibitionID"),
            ExhvisitorIDList: ExhvisitorIDList,
        }
        console.log("ExhibitionID-Action--------------------------->", params)

        const res = await axiosPost(generateAdditionalVisitorTaxInvoiceUrl, params, headers);
        dispatch({
            type: GENERATE_VISITOR_TAX_INVOICE,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const sendVisitorInvoiceMail_action = (VisitorList, TaxInvoiceList) => async (dispatch) => {
    try {
        const params = {
            ExhibitionID: sessionStorage.getItem("sessionExhibitionID"),
            VisitorList: VisitorList,
            TaxInvoiceList: TaxInvoiceList
        }
        console.log("ReceiptListSearch -Action--------------------------->", params)

        const res = await axiosGet(sendVisitorInvoiceMailUrl, params, headers);
        dispatch({
            type: SHARE_VISITOR_TAX_INVOICE,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
}